import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5abd2ee4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-animation-panel" }
const _hoisted_2 = {
  key: 0,
  class: "element-animation"
}
const _hoisted_3 = { class: "type-title" }
const _hoisted_4 = { class: "pool-item-wrapper" }
const _hoisted_5 = ["onMouseenter", "onClick"]
const _hoisted_6 = {
  key: 0,
  class: "mask"
}
const _hoisted_7 = {
  key: 1,
  class: "tip"
}
const _hoisted_8 = { class: "sequence-content" }
const _hoisted_9 = { class: "index" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "handler" }
const _hoisted_12 = {
  key: 0,
  class: "configs"
}
const _hoisted_13 = { class: "config-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"35%"} }, "持续时长：", -1))
const _hoisted_15 = { class: "config-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"35%"} }, "触发方式：", -1))
const _hoisted_17 = { class: "config-item" }

import { computed, ref, watch } from 'vue'
import { nanoid } from 'nanoid'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTAnimation } from '@/types/slides'
import { 
  ENTER_ANIMATIONS,
  EXIT_ANIMATIONS,
  ATTENTION_ANIMATIONS,
  ANIMATION_DEFAULT_DURATION,
  ANIMATION_DEFAULT_TRIGGER,
  ANIMATION_CLASS_PREFIX,
} from '@/configs/animation'
import { ELEMENT_TYPE_ZH } from '@/configs/element'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import Tabs from '@/components/Tabs.vue'
import Divider from '@/components/Divider.vue'
import Button from '@/components/Button.vue'
import Draggable from 'vuedraggable'
import NumberInput from '@/components/NumberInput.vue'
import Select from '@/components/Select.vue'
import Popover from '@/components/Popover.vue'

type AnimationType = 'in' | 'out' | 'attention'
interface TabItem {
  key: AnimationType
  label: string
  color: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementAnimationPanel',
  setup(__props) {

const animationEffects: { [key: string]: string } = {}
for (const effect of ENTER_ANIMATIONS) {
  for (const animation of effect.children) {
    animationEffects[animation.value] = animation.name
  }
}
for (const effect of EXIT_ANIMATIONS) {
  for (const animation of effect.children) {
    animationEffects[animation.value] = animation.name
  }
}
for (const effect of ATTENTION_ANIMATIONS) {
  for (const animation of effect.children) {
    animationEffects[animation.value] = animation.name
  }
}

const animationTypes: AnimationType[] = ['in', 'out', 'attention']

const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(useMainStore())
const { currentSlide, formatedAnimations, currentSlideAnimations } = storeToRefs(slidesStore)

const tabs: TabItem[] = [
  { key: 'in', label: '入场', color: '#68a490' },
  { key: 'out', label: '退场', color: '#d86344' },
  { key: 'attention', label: '强调', color: '#e8b76a' },
]
const activeTab = ref('in')
const animateIn = ref(false)
watch(() => handleElementId.value, () => {
  animationPoolVisible.value = false
})

const hoverPreviewAnimation = ref('')
const animationPoolVisible = ref(false)

const { addHistorySnapshot } = useHistorySnapshot()

// 当前页面的动画列表
const animationSequence = computed(() => {
  const animationSequence = []
  for (let i = 0; i < formatedAnimations.value.length; i++) {
    const item = formatedAnimations.value[i]
    for (let j = 0; j < item.animations.length; j++) {
      const animation = item.animations[j]
      const el = currentSlide.value.elements.find(el => el.id === animation.elId)
      if (!el) continue

      const elType = ELEMENT_TYPE_ZH[el.type]
      const animationEffect = animationEffects[animation.effect]
      animationSequence.push({
        ...animation,
        index: j === 0 ? i + 1 : '',
        elType,
        animationEffect,
      })
    }
  }
  return animationSequence
})

// 当前选中元素的入场动画信息
const handleElementAnimation = computed(() => {
  const animations = currentSlideAnimations.value
  const animation = animations.filter(item => item.elId === handleElementId.value)
  return animation || []
})

// 删除元素动画
const deleteAnimation = (id: string) => {
  const animations = currentSlideAnimations.value.filter(item => item.id !== id)
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 拖拽修改动画顺序后同步数据
const handleDragEnd = (eventData: { newIndex: number; oldIndex: number }) => {
  const { newIndex, oldIndex } = eventData
  if (newIndex === undefined || oldIndex === undefined || newIndex === oldIndex) return

  const animations: PPTAnimation[] = JSON.parse(JSON.stringify(currentSlideAnimations.value))
  const animation = animations[oldIndex]
  animations.splice(oldIndex, 1)
  animations.splice(newIndex, 0, animation)
  
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 执行动画预览
const runAnimation = (elId: string, effect: string, duration: number) => {
  const elRef = document.querySelector(`#editable-element-${elId} [class^=editable-element-]`)
  if (elRef) {
    const animationName = `${ANIMATION_CLASS_PREFIX}${effect}`
    document.documentElement.style.setProperty('--animate-duration', `${duration}ms`)
    elRef.classList.add(`${ANIMATION_CLASS_PREFIX}animated`, animationName)

    const handleAnimationEnd = () => {
      document.documentElement.style.removeProperty('--animate-duration')
      elRef.classList.remove(`${ANIMATION_CLASS_PREFIX}animated`, animationName)
    }
    elRef.addEventListener('animationend', handleAnimationEnd, { once: true })
  }
}

// 执行所有动画预览
const runAllAnimation = async () => {
  animateIn.value = !animateIn.value
  for (let i = 0; i < animationSequence.value.length; i++) {
    if (!animateIn.value) break
    const item = animationSequence.value[i]
    if (item.index !== 1 && item.trigger !== 'meantime') await new Promise(resolve => setTimeout(resolve, item.duration + 100)) 
    runAnimation(item.elId, item.effect, item.duration)
    if (i >= animationSequence.value.length - 1) animateIn.value = false
  }
}

// 修改元素动画持续时间
const updateElementAnimationDuration = (id: string, duration: number) => {
  if (duration < 100 || duration > 5000) return

  const animations = currentSlideAnimations.value.map(item => {
    if (item.id === id) return { ...item, duration }
    return item
  })
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 修改触发方式
const updateElementAnimationTrigger = (id: string, trigger: 'click' | 'meantime' | 'auto') => {
  const animations = currentSlideAnimations.value.map(item => {
    if (item.id === id) return { ...item, trigger }
    return item
  })
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 修改元素动画，并执行一次预览
const updateElementAnimation = (type: AnimationType, effect: string) => {
  const animations = currentSlideAnimations.value.map(item => {
    if (item.id === handleAnimationId.value) return { ...item, type, effect }
    return item
  })
  slidesStore.updateSlide({ animations })
  animationPoolVisible.value = false
  addHistorySnapshot()

  const animationItem = currentSlideAnimations.value.find(item => item.elId === handleElementId.value)
  const duration = animationItem?.duration || ANIMATION_DEFAULT_DURATION

  setTimeout(() => {
    runAnimation(handleElementId.value, effect, duration)
  }, 0)
}

const handleAnimationId = ref('')
// 添加元素动画，并执行一次预览
const addAnimation = (type: AnimationType, effect: string) => {
  if (handleAnimationId.value) {
    updateElementAnimation(type, effect)
    return
  }

  const animations: PPTAnimation[] = JSON.parse(JSON.stringify(currentSlideAnimations.value))
  animations.push({
    id: nanoid(10),
    elId: handleElementId.value,
    type,
    effect,
    duration: ANIMATION_DEFAULT_DURATION,
    trigger: ANIMATION_DEFAULT_TRIGGER,
  })
  slidesStore.updateSlide({ animations })
  animationPoolVisible.value = false
  addHistorySnapshot()

  setTimeout(() => {
    runAnimation(handleElementId.value, effect, ANIMATION_DEFAULT_DURATION)
  }, 0)
}

// 动画选择面板打开600ms后再移除遮罩层，否则打开面板后迅速滑入鼠标预览会导致抖动
const popoverMaskHide = ref(false)
const handlePopoverVisibleChange = (visible: boolean) => {
  if (visible) {
    setTimeout(() => popoverMaskHide.value = true, 600)
  }
  else popoverMaskHide.value = false
}

const openAnimationPool = (elementId: string) => {
  animationPoolVisible.value = true
  handleAnimationId.value = elementId
  handlePopoverVisibleChange(true)
}

const animations = {
  in: ENTER_ANIMATIONS,
  out: EXIT_ANIMATIONS,
  attention: ATTENTION_ANIMATIONS,
}

return (_ctx: any,_cache: any) => {
  const _component_IconEffects = _resolveComponent("IconEffects")!
  const _component_IconClick = _resolveComponent("IconClick")!
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")!
  const _component_IconCloseSmall = _resolveComponent("IconCloseSmall")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(handleElement))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Popover, {
            trigger: "click",
            value: animationPoolVisible.value,
            "onUpdate:value": [
              _cache[3] || (_cache[3] = ($event: any) => ((animationPoolVisible).value = $event)),
              _cache[4] || (_cache[4] = visible => handlePopoverVisibleChange(visible))
            ],
            style: {"width":"100%"}
          }, {
            content: _withCtx(() => [
              _createVNode(Tabs, {
                tabs: tabs,
                value: activeTab.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                tabsStyle: { marginBottom: '20px' },
                tabStyle: { width: '33.333%' },
                spaceAround: ""
              }, null, 8, ["value"]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(animationTypes, (key) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (activeTab.value === key)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['animation-pool', key]),
                        key: key
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(animations[key], (effect) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "pool-type",
                            key: effect.name
                          }, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(effect.name) + "：", 1),
                            _createElementVNode("div", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effect.children, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "pool-item",
                                  key: item.name,
                                  onMouseenter: ($event: any) => (hoverPreviewAnimation.value = item.value),
                                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverPreviewAnimation.value = '')),
                                  onClick: ($event: any) => (addAnimation(key, item.value))
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["animation-box", [
                        `${_unref(ANIMATION_CLASS_PREFIX)}animated`,
                        `${_unref(ANIMATION_CLASS_PREFIX)}fast`,
                        hoverPreviewAnimation.value === item.value && `${_unref(ANIMATION_CLASS_PREFIX)}${item.value}`,
                      ]])
                                  }, _toDisplayString(item.name), 3)
                                ], 40, _hoisted_5))
                              }), 128))
                            ])
                          ]))
                        }), 128)),
                        (!popoverMaskHide.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 64))
            ]),
            default: _withCtx(() => [
              _createVNode(Button, {
                class: "element-animation-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleAnimationId.value = ''))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconEffects, { style: {"margin-right":"5px"} }),
                  _createTextVNode(" 添加动画 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_IconClick, { style: {"margin-right":"5px"} }),
          _createTextVNode(" 选中画布中的元素添加动画")
        ])),
    _createVNode(Divider),
    _createVNode(_unref(Draggable), {
      class: "animation-sequence",
      modelValue: animationSequence.value,
      animation: 200,
      scroll: true,
      scrollSensitivity: 50,
      handle: ".sequence-content",
      itemKey: "id",
      onEnd: handleDragEnd
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["sequence-item", [element.type, { 'active': _unref(handleElement)?.id === element.elId }]])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(element.index), 1),
            _createElementVNode("div", _hoisted_10, "【" + _toDisplayString(element.elType) + "】" + _toDisplayString(element.animationEffect), 1),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createVNode(_component_IconPlayOne, {
                class: "handler-btn",
                onClick: ($event: any) => (runAnimation(element.elId, element.effect, element.duration))
              }, null, 8, ["onClick"]), [
                [_directive_tooltip, '预览']
              ]),
              _withDirectives(_createVNode(_component_IconCloseSmall, {
                class: "handler-btn",
                onClick: ($event: any) => (deleteAnimation(element.id))
              }, null, 8, ["onClick"]), [
                [_directive_tooltip, '删除']
              ])
            ])
          ]),
          (handleElementAnimation.value[0]?.elId === element.elId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(Divider, { style: {"margin":"16px 0"} }),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(NumberInput, {
                    min: 500,
                    max: 3000,
                    step: 500,
                    value: element.duration,
                    "onUpdate:value": value => updateElementAnimationDuration(element.id, value),
                    style: {"width":"65%"}
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(Select, {
                    value: element.trigger,
                    "onUpdate:value": value => updateElementAnimationTrigger(element.id, value as 'click' | 'meantime' | 'auto'),
                    style: {"width":"65%"},
                    options: [
                  { label: '主动触发', value: 'click' },
                  { label: '与上一动画同时', value: 'meantime' },
                  { label: '上一动画之后', value: 'auto' },
                ]
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(Button, {
                    style: {"width":"100%"},
                    onClick: ($event: any) => (openAnimationPool(element.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("更换动画")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (animationSequence.value.length >= 2)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(Divider),
          _createVNode(Button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (runAllAnimation()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(animateIn.value ? '停止预览' : '预览全部'), 1)
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})